<template>
  <div>
    <run-transfer></run-transfer>
  </div>
</template>

<script>
  import RunTransfer from "./../../components/transfer/Run";

  export default {
    metaInfo() {
      return {
        title: this.$vuetify.lang.t("$vuetify.transfer.title2")
      };
    },
    components: {
      RunTransfer
    }
  }
</script>

<style scoped>

</style>
